import { render, staticRenderFns } from "./CollectingIcon.vue?vue&type=template&id=a43bc66c&"
import script from "./CollectingIcon.vue?vue&type=script&lang=js&"
export * from "./CollectingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports